import { useState, useEffect } from "react";
import { fetchProductCatalog } from "services/api/haulpay";
import { getUserRole, Role } from "../helpers/subscriptionPlans";
import { useUserFeature } from "./useUserFeature";

export interface ProductCatalog {
  carrier: any;
  broker: any;
  shipper: any;
}

export function useProductCatalog<T extends Record<Role, any> = ProductCatalog>() {
  const [catalog, setCatalog] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const { isCarrier, isBroker, isShipper } = useUserFeature();
  const userRole = getUserRole(isCarrier, isBroker, isShipper);
  const role: Role = userRole ?? "carrier";

  useEffect(() => {
    fetchProductCatalog<T>()
      .then((data) => {
        setCatalog(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, []);

  return {
    productCatalog: catalog,
    subscriptionPlan: catalog ? catalog[role] || {} : {},
    loading,
    error
  };
}
